import React from 'react';
import { Container, Row } from 'reactstrap';
import { TachoReleaseInformationModel } from '../../../../core/domainModels/versions/TachoInstallerModel';
import './styles.scss';

interface VersionsDetailsProps {
    data?: TachoReleaseInformationModel;
}

export const VersionsDetails = (props: VersionsDetailsProps) => {
    return (
        <Container fluid className="versionsDetailsContainer d-flex flex-column px-5 mt-2">
            <Row>
                <p>{props.data?.patchNotes}</p>
            </Row>
        </Container>
    );
};
